module.exports = __webpack_public_path__ + "images/pro/img-cipher-mobile-62300df8a06523f78a233eeb58aaed18.png";